import {Container, Row, Card, Col} from 'react-bootstrap'
import './Profile.css'
import AnimatedText from "../components/AnimatedText";

function Profile() {

  return (
    <div className='profile'>
      <Container>
            <Card className='profile-card'>
              <div className='ratio'>
                <img src="../gif/pfp.gif" alt="Profile" className="profile-image" />
              </div>
              <Card.Body>
                <Card.Title><h3>About Me</h3></Card.Title>
                <AnimatedText
                  text="Hi 🐐 im SoLAN, a goat living inside your computer"
                  characters="01x"
                  revealDirection="start"
                  sequential
                  useOriginalCharsOnly={false}
                />
                <AnimatedText
                  text="I am an illustrator focusing in character art and design with bold lighting, texture, and color!"
                  characters="01x"
                  revealDirection="start"
                  sequential
                  useOriginalCharsOnly={false}
                />
                <Row>
                  <Col>
                    <Card.Text className='links'>
                      <a href="https://www.instagram.com/so.lan06/" target="_blank" rel="noopener noreferrer" className="soc-link">instagram</a>
                      <a href="https://x.com/so_lan06?s=21" target="_blank" rel="noopener noreferrer" className="soc-link">twitter</a>
                      <a href="https://www.tiktok.com/@so.lan06" target="_blank" rel="noopener noreferrer" className="soc-link">tiktok</a>
                      <a href="https://vgen.co/so_lan06" target="_blank" rel="noopener noreferrer" className="soc-link">vgen</a>
                      <a href="https://www.facebook.com/so.lan006" target="_blank" rel="noopener noreferrer" className="soc-link">facebook</a>
                    </Card.Text>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
      </Container>
    </div>
  )
}

export default Profile
